import { type TFunction, Trans } from 'next-i18next';
import type { UseQueryPopupOpenCreatePopupLink } from '@mwl/core-lib';
import CloseIcon from '@public/assets/common/icons/close.svg';
import DoubleCheckIcon from '@public/assets/common/icons/doubleCheck.svg';
import ArrowRightIcon from '@public/assets/promo/icons/arrowRight.svg';
import { routes } from '@/constants';
import { Button } from '../Button/Button';
import type { PromoFieldMutationState } from './components/PromoFieldForm/PromoFieldForm';
import styles from './PromoField.module.scss';
export const strings = {
  promo: {
    placeholder: 'voucher.promo.placeholder',
    tooltip: 'voucher.promo.tooltip',
    bonus: 'voucher.promo.activated_bonus',
    reward: 'voucher.promo.activated_reward'
  },
  auth: {
    placeholder: 'voucher.common.placeholder',
    bonus: 'voucher.common.activated_bonus',
    reward: 'voucher.common.activated_reward'
  }
};
export function getTooltipContent(state: PromoFieldMutationState | null, createLinkProps: UseQueryPopupOpenCreatePopupLink, t: TFunction, variant: 'auth' | 'promo') {
  if (state?.error) {
    return Array.isArray(state.error.message) ? t(state.error.message, {
      ns: 'common'
    }) : state.error.message;
  }
  let i18nKey = variant === 'promo' ? strings.promo.tooltip : undefined;
  const values: Dictionary<string> = {
    bonus: ''
  };
  let href: ReturnType<typeof createLinkProps> = {
    href: ''
  };
  if (state?.isSuccess) {
    const {
      isBonusPacketPresent,
      rewardDescription: bonus
    } = state.data || {
      isBonusPacketPresent: true
    };
    i18nKey = isBonusPacketPresent ? strings[variant].bonus : strings[variant].reward;
    values.bonus = bonus || '';
    href = isBonusPacketPresent ? createLinkProps({
      queryName: 'deposit',
      options: {
        shallow: true
      }
    }) : {
      href: routes.loyalty
    };
  }
  if (!i18nKey) {
    return null;
  }
  return <Trans ns="common" i18nKey={i18nKey} values={values} components={[<span className={styles.highlight} key="highlight" />, <Button as="link" {...href} type="button" variant="text" uppercase={false} className={styles.link} key="link" />]} data-sentry-element="Trans" data-sentry-component="getTooltipContent" data-sentry-source-file="PromoField.utils.tsx" />;
}
export function getPromoFieldActionIcon(state: PromoFieldMutationState | null) {
  if (state?.error) {
    return CloseIcon;
  }
  if (state?.isSuccess) {
    return DoubleCheckIcon;
  }
  return ArrowRightIcon;
}